import { post } from '@utils/fetch';

export interface PostContactRequest {
  email: string;
  message: string;
  name: string;
  subject: string;
}

export async function post_contact(request: PostContactRequest) {
  return await post<{ id: number }[]>(`${process.env.NEXT_PUBLIC_API_URL}/contact`, request);
}
